import { motion, useInView } from "framer-motion";
import { useRef, useEffect, useState } from "react";
import { Users, FileText, School, Bot } from "lucide-react";

const stats = [
  { icon: Users, value: 1000, suffix: "+", label: "Students" },
  { icon: FileText, value: 500, suffix: "+", label: "Exams Created" },
  { icon: School, value: 50, suffix: "+", label: "Schools" },
  { icon: Bot, value: 24, suffix: "/7", label: "AI Support" },
];

const CountUp = ({ target, suffix }: { target: number; suffix: string }) => {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLSpanElement>(null);
  const isInView = useInView(ref, { once: true });

  useEffect(() => {
    if (!isInView) return;
    let start = 0;
    const duration = 1500;
    const step = Math.ceil(target / (duration / 16));
    const timer = setInterval(() => {
      start += step;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(start);
      }
    }, 16);
    return () => clearInterval(timer);
  }, [isInView, target]);

  return (
    <span ref={ref} className="text-3xl md:text-4xl font-black text-primary">
      {count}{suffix}
    </span>
  );
};

const StatsStrip = () => {
  return (
    <section className="py-12 px-6 bg-muted/50 border-y border-border">
      <div className="container mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="flex flex-col items-center text-center gap-2"
            >
              <stat.icon className="h-6 w-6 text-primary mb-1" />
              <CountUp target={stat.value} suffix={stat.suffix} />
              <span className="text-sm text-muted-foreground font-medium">{stat.label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsStrip;
